<script setup lang="ts">
  import { useAgencyStructureSelectors } from '../../composables/useAgencyStructureSelectors'
  import AgencyGroupListItem from './AgencyGroupListItem.vue'

  const { rootGroup } = useAgencyStructureSelectors()
</script>

<template>
  <AgencyGroupListItem v-if="rootGroup" :node="rootGroup" />
</template>
